import React from 'react';

interface HolidayProps {
  className?: string;
  width?: number;
  height?: number;
}

const HolidayIcon = function HolidayIcon({
  className,
  width,
  height,
}: HolidayProps): JSX.Element {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      width={width}
      height={height}
      viewBox="0 0 32 32"
    >
      <rect x="4" y="8" width="24" height="20" rx="2" fill="#28364C" stroke="#28364C" />
      <path d="M4 12C4 10.1144 4 9.17157 4.58579 8.58579C5.17157 8 6.11438 8 8 8H24C25.8856 8 26.8284 8 27.4142 8.58579C28 9.17157 28 10.1144 28 12V13.3333H4V12Z" fill="white" stroke="#28364C" />
      <path d="M9.33301 5.60156L9.33301 9.60156" stroke="#28364C" strokeLinecap="round" />
      <path d="M22.667 5.60156L22.667 9.60156" stroke="#28364C" strokeLinecap="round" />
      <rect x="9.3335" y="16" width="5.33333" height="2.66667" rx="0.5" fill="white" />
      <rect x="9.3335" y="21.332" width="5.33333" height="2.66667" rx="0.5" fill="white" />
      <rect x="17.3335" y="16" width="5.33333" height="2.66667" rx="0.5" fill="white" />
      <rect x="17.3335" y="21.332" width="5.33333" height="2.66667" rx="0.5" fill="white" />
    </svg>
  );
};

HolidayIcon.defaultProps = {
  className: '',
  width: 32,
  height: 32,
};

export default HolidayIcon;
